import React from 'react';
import PropTypes from 'prop-types';
import LeftPaginationArrow from "../../../icon-components/left-pagination-arrow";
import RightPaginationArrow from "../../../icon-components/right-pagination-arrow";

var Navbar = function Navbar(_ref) {
  var showNextButton = _ref.showNextButton,
      showPreviousButton = _ref.showPreviousButton,
      onPreviousClick = _ref.onPreviousClick,
      onNextClick = _ref.onNextClick,
      className = _ref.className;
  return React.createElement("div", {
    className: className
  }, showPreviousButton && React.createElement("button", {
    className: "DayPicker-left-arrow",
    onClick: function onClick() {
      return onPreviousClick();
    },
    type: "button"
  }, React.createElement(LeftPaginationArrow, null)), showNextButton && React.createElement("button", {
    className: "DayPicker-right-arrow",
    onClick: function onClick() {
      return onNextClick();
    },
    type: "button"
  }, React.createElement(RightPaginationArrow, null)));
};

Navbar.propTypes = {
  showNextButton: PropTypes.bool,
  showPreviousButton: PropTypes.bool,
  onPreviousClick: PropTypes.func,
  onNextClick: PropTypes.func,
  className: PropTypes.string
};
export default Navbar;